import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { getToken } from '@/utils/auth'; // getToken from cookie

import { fetchDict } from '@/api/MLXC/countryServe/partyManage';
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/venueArea/venueArea';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, 'sssss');

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传照片");
      }

      callback();
    };

    return {
      rules: {
        areaName: [{
          required: true,
          message: '请输入区域名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '请输入区域地址',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        priceRange: [{
          required: true,
          message: '请输入价格区间',
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: '长度在 1 到 20 个字符',
          trigger: 'change'
        }],
        areaType: [{
          required: true,
          message: '请选择场地类型',
          trigger: 'change'
        }],
        // areaUse: [{ required: true, message: '请选择场地用途', trigger: 'change' }],
        actiShortName: [{
          required: true,
          message: '请输入商品和服务分类开票简称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        actiClassificationCode: [{
          required: true,
          message: '请输入商品和税收分类开票编码',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        actiInviceName: [{
          required: true,
          message: '请输入开票项目名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: 'blur'
        }],
        lat: [{
          required: true,
          message: '请在地图上选点',
          trigger: 'change'
        }],
        lng: [{
          required: true,
          message: '请在地图上选点',
          trigger: 'change'
        }]
      },
      childData: {
        areaName: '',
        remark: ''
      },
      areaTypeOptions: [],
      areaUseOptions: [],
      pricingMethodOptions: [],
      files: [],
      fileList: [],
      changeFileList: [],
      delImg: [],
      dialogImageUrl: '',
      dialogVisible: false,
      importHeaders: {
        'access-token': getToken()
      },
      uploadUrl: '',
      downloadUrl: '',
      mapAPI: ''
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.listenerEvent); // 清空地图控件

    window.frames['map1'].postMessage({
      type: 'closeMap'
    }, '*');
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.changeFileList = [];
      this.delImg = [];
      this.files = [];
      this.fileList = [];
      this.getAreaType();
      this.getPricingMethodType();
      this.mapAPI = './static/gaodeMapNew.html?from=0';

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.childData.pricingMethod = _this2.childData.pricingMethod.toString();
          _this2.childData.areaType = _this2.childData.areaType.toString();

          _this2.getUseType(false);

          _this2.childData.areaUse = _this2.childData.areaUse ? _this2.childData.areaUse.toString() : '';

          if (_this2.childData.fileList !== null) {
            _this2.childData.fileList.forEach(function (item) {
              var imgData = {
                fileId: item.fileId,
                fileType: 2,
                id: item.fileId,
                imgPath: item.fileId,
                imgId: item.fileId,
                url: _this2.downloadUrl + item.fileId
              };
              console.log(_this2.imgData, 'ssss');

              _this2.fileList.push(imgData);
            });

            _this2.files = cloneDeep(_this2.fileList);
          }

          _this2.dingwei();
        });
      } else {
        var self = this;
        setTimeout(function () {
          self.clearMap();
        }, 1000);
        this.childData = {
          areaName: '',
          remark: '',
          lat: '',
          lng: '',
          areaType: ''
        };
      }

      window.addEventListener('message', this.listenerEvent);
    },
    getAreaType: function getAreaType() {
      var _this3 = this;

      fetchDict({
        dicType: 'area_type'
      }).then(function (res) {
        _this3.areaTypeOptions = res.data.data;
      });
    },
    getUseType: function getUseType(isInit) {
      var _this4 = this;

      if (isInit) {
        delete this.childData.areaUse;
      }

      if (this.childData.areaType > 0) {
        fetchDict({
          dicType: 'area_use',
          upDicValue: this.childData.areaType
        }).then(function (res) {
          _this4.areaUseOptions = res.data.data;
        });
      }
    },
    getPricingMethodType: function getPricingMethodType() {
      var _this5 = this;

      fetchDict({
        dicType: 'pricing_method'
      }).then(function (res) {
        _this5.pricingMethodOptions = res.data.data;
      });
    },
    handleRemarkInput: function handleRemarkInput(val) {
      if (val.length > 200) {
        this.$message({
          message: '备注的最大长度不能超过200个字符',
          type: 'warning'
        });
      }

      this.$set(this.childData, 'remark', val.slice(0, 200));
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this6.childData.fileList = _this6.fileList;

          if (_this6.keyValue > 0) {
            fetchUpdate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit('handCancle', true);

                _this6.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit('handCancle', true);

                _this6.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: 'valid'
          });
        }
      }); // 清空地图标识

      window.frames['map2'].postMessage({
        type: 'reload'
      }, '*');
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false); // 清空地图标识

      window.frames['map2'].postMessage({
        type: 'reload'
      }, '*');
    },
    changemap: function changemap(e) {
      this.childData.lng = e.data.lng;
      this.childData.lat = e.data.lat;
    },
    sw: function sw() {
      window.frames['map2'].postMessage({
        type: 'setPoint'
      }, '*');
    },
    clearMap: function clearMap() {
      window.frames['map2'].postMessage({
        type: 'reload'
      }, '*');
    },
    dingwei: function dingwei() {
      var lo = this.childData.lng;
      var lat = this.childData.lat;

      if (lo === '0' || lo === 0) {
        window.frames['map2'].postMessage({
          type: 'reload'
        }, '*');
        return;
      }

      window.frames['map2'].postMessage({
        // 此处在修改数据时进行点位还原
        type: 'editPoint',
        lng: lo,
        lat: lat
      }, '*');
    },
    listenerEvent: function listenerEvent(e) {
      var info = this; // 点击记录坐标点事件

      if (e.data.type === 'getPoint') {
        info.changemap(e);
      }

      if (e.data.type === 'loadOver') {
        info.dingwei();
      }
    },
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.changeFileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.$refs.dataForm.clearValidate('files');
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传1个文件!',
        type: 'danger'
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'JPEG' || extension === 'png' || extension === 'bmp' || extension === 'gif';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/jpeg/png/bmp/gif 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this7 = this;

      var currentUrl = 0; // 获取当前删除文件的fileId

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.fileId;
        this.delImg.push(file.imgId);
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.fileList.splice(index, 1);

          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.changeFileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg' || str === 'image/gif' || str === 'image/bmp') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};